<template>
  <div>
    <div class="checkbox-inline">
      <Field
        :id="name"
        v-model="checkboxvalue"
        :rules="validate"
        :label="name"
        :name="name"
        type="checkbox"
        :disabled="disabled"
        :value="true"
        :unchecked-value="false"
      />
      <label :for="name">
        <strong v-if="label" v-text="label" />
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TickCheckbox',
  components: {},
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Boolean,
      default: undefined
    },
    validate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checkboxvalue: undefined
    };
  },
  watch: {
    modelValue(val) {
      this.checkboxvalue = val;
    },
    checkboxvalue() {
      this.$emit('update:modelValue', this.checkboxvalue);
    }
  },
  mounted() {
    this.checkboxvalue = this.modelValue;
  }
};
</script>
<style lang="scss" scoped>
@import 'src/styles/all.scss';

label::before {
  box-shadow: 0px 0px 0 1px $medium-gray;
  border: 5px solid $white;
  padding: 0;
}

label::after {
  top: unset;
}
</style>
